import cx from 'classnames'
import * as React from 'react'

import type { ProcedurePreviewStepViewModel } from '../../view-models/ProcedurePreviewStepViewModel'
import Icon from '../Icon/Icon'
import Image from '../Image/Image'
import Paragraph from '../Paragraph/Paragraph'
import styles from './procedurePreviewStep-style.css'
import Heading from '@/components/Heading/Heading'

type Props = ProcedurePreviewStepViewModel
type State = {}

class ProcedurePreviewStep extends React.Component<Props, State> {
  static displayName = 'ProcedurePreviewStep'
  static defaultProps = {}

  render() {
    const { icon, image, text, index, className, stepTitle } = this.props
    if (!icon && !text) return null

    return (
      <div className={cx(styles.carouselStep, icon ? styles.hasIcon : '', className)}>
        <Heading tag={'h2'} level={2} className={styles.number}>{index}</Heading>
        {image && (
          <div className={styles.image}>
            <Image {...image} />
          </div>
        )}
        <div className={styles.iconWrapper}>
          {icon && !image && <Icon iconSrc={icon} width="50px" height="50px" />}
        </div>
        {stepTitle && <div className={styles.stepTitle}>{stepTitle}</div>}
        {text && (
          <Paragraph marginBottom="none" className={styles.text} weight={'light'} size={'normal'}>
            {text}
          </Paragraph>
        )}
      </div>
    )
  }
}

export default ProcedurePreviewStep
